export { default } from "bullitttime-embercomponents/components/fullscreen-button";
